import { useMutation, useQuery } from "@tanstack/react-query"
import { IAcceptInvitation, ICreateInvitation } from "../models/User"
import rolesApi from "../api/roles.api"
import userApi from "../api/user.api"
import { QueryKeys } from "./querykeys"
import { setYearsOptionsOrganizationCreatedAt } from "../components/utils/constant"

export const useQueryGetUserMe = (options?: { enabled?: boolean }) => {
  return (
    useQuery({
      enabled: options?.enabled ?? true,
      queryKey: [QueryKeys.GET_USER_ME],
      queryFn: async () => {
        try {
          const res = await userApi.getMe()
          if (res.status === 200) {
            setYearsOptionsOrganizationCreatedAt(res.data?.currentOrganization?.createdAt)
            if (res.data?.extra?.initialTour === false) {
              localStorage.setItem('luca_tour_completed', 'true')
              localStorage.setItem('luca_tour_active', 'false')
            }
            return res.data
          }
        } catch (error) {
          return null
        }
      }
    })
  )
}


export const useQueryGetUsersAll = () => {
  return useQuery({
    queryKey: [QueryKeys.GET_USERS_ALL],
    queryFn: async () => {
      try {
        const res = await userApi.getAll()
        if (res.status === 200) {
          return res.data
        }
      } catch (error) {
        return null
      }
    }
  })
}


export const useMutationInviteUser = () => {
  return useMutation({
    mutationFn: async (data: ICreateInvitation) => {
      try {
        const res = await rolesApi.invitateUserWithEmail(data)
        if (res.status === 200 || res.status === 201) {
          return res.data
        }
      } catch (error) {
        return null
      }
    }
  })
}


export const useMutationAcceptInvitation = () => {
  return useMutation({
    mutationFn: async (data: IAcceptInvitation) => {
      const res = await userApi.acceptInvitation(data)
      if (res.status === 200 || res.status === 201) {
        return res.data
      }
      throw new Error('Error al aceptar la invitación')
    },
    retry: 2,
    retryDelay: 1_000 * 6
  })
}


export const useMutationSignIn = () => {
  return useMutation({
    mutationFn: async (firebaseToken: string) => {
      try {
        const res = await userApi.signIn(firebaseToken)
        if (res.status === 200 || res.status === 201) {
          return res.data
        }
      } catch (error) {
        return null
      }
    }
  })
}


export const useMutationAdminPanelHandoff = () => {
  return useMutation({
    mutationFn: async () => {
      const res = await userApi.createAdminPanelHandoff()
      return res.data.entryUrl
    }
  })
}
